module.exports = __webpack_public_path__ + "img/earth.44e0f9f.png";